"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const SessionContext_1 = require("../../context/SessionContext");
const SessionBuilderContext_1 = require("../../context/SessionBuilderContext");
const TemplateSelectionModal_1 = __importDefault(require("../TemplateSelectionModal"));
const sessionBuilder_1 = require("../../api/sessionBuilder");
const templateLibraryApi_1 = require("../../api/templateLibraryApi");
const TemplateSelectionWrapper = ({ children, newTemplateGenerate = false }) => {
    const { session, isNewSession, setSession } = (0, SessionContext_1.useSession)();
    const { setGeneratedCode, setError } = (0, SessionBuilderContext_1.useSessionBuilder)();
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const [showTemplateModal, setShowTemplateModal] = (0, react_1.useState)(false);
    const [hasShownModal, setHasShownModal] = (0, react_1.useState)(false);
    const [templateIdFromUrl, setTemplateIdFromUrl] = (0, react_1.useState)(null);
    // Check for templateId in URL params
    (0, react_1.useEffect)(() => {
        const templateId = searchParams.get('templateId');
        if (templateId) {
            setTemplateIdFromUrl(parseInt(templateId));
        }
    }, [searchParams]);
    // Auto-select template from URL or show template modal
    (0, react_1.useEffect)(() => {
        if (isNewSession && (session === null || session === void 0 ? void 0 : session.docType) && !hasShownModal && !showTemplateModal) {
            if (templateIdFromUrl) {
                // Auto-select template from URL
                handleAutoSelectTemplate(templateIdFromUrl);
                setHasShownModal(true);
            }
            else if (session.docType === sessionBuilder_1.DOC_TYPE.PPT) {
                // Show template modal for new PPT sessions
                setShowTemplateModal(true);
                setHasShownModal(true);
            }
        }
    }, [isNewSession, session === null || session === void 0 ? void 0 : session.docType, hasShownModal, showTemplateModal, templateIdFromUrl]);
    const handleAutoSelectTemplate = (templateId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            console.log(`🔄 Auto-selecting template ${templateId} from URL`);
            // Fetch template details
            const template = yield templateLibraryApi_1.templateLibraryApi.getTemplateById(templateId);
            // Create session with template
            const newSession = yield (0, sessionBuilder_1.createSession)(session === null || session === void 0 ? void 0 : session.docType, templateId, `${template.name} - ${new Date().toLocaleDateString()}`);
            // Set the generated code and session
            setGeneratedCode(newSession.html || '');
            setSession(newSession);
            // Update URL to remove templateId parameter
            const newUrl = `/${newSession.id}/form-builder`;
            window.history.replaceState(null, '', newUrl);
            console.log(`✅ Auto-selected template and created session:`, newSession.id);
        }
        catch (err) {
            console.error('❌ Failed to auto-select template:', err);
            setError('Failed to load template. Please try again.');
            // Show template modal as fallback
            setShowTemplateModal(true);
        }
    });
    const handleSelectTemplate = (templateData) => __awaiter(void 0, void 0, void 0, function* () {
        if (!(session === null || session === void 0 ? void 0 : session.docType)) {
            console.error('No docType available for session creation');
            return;
        }
        try {
            console.log("🆕 Creating new session from template:", templateData.name);
            // Create the session with templateId if it's not a blank template
            const newSession = yield (0, sessionBuilder_1.createSession)(session.docType, templateData.templateId, templateData.name);
            console.log("✅ Session created with ID:", newSession.id);
            console.log("📝 Session name:", newSession.name);
            console.log("📄 Session HTML content:", newSession.html ? "Present" : "Missing");
            // Set the generated code for the UI from the session response
            if (newSession.html) {
                console.log("🎯 Using HTML from session response");
                setGeneratedCode(newSession.html);
            }
            else if (templateData.templateId) {
                // If we selected a template but session doesn't have HTML, this is an error
                console.error("❌ Template selected but session has no HTML content");
                throw new Error("Template HTML content not found in session response");
            }
            else {
                // For blank template (templateId is undefined), start with minimal content
                console.log("📝 Using blank template content");
                setGeneratedCode(`
          <div class="presentation-slide">
            <h1>Your Presentation</h1>
            <p>Start building your content here...</p>
          </div>
        `);
            }
            // Update the session context
            setSession(newSession);
            // Replace the URL without causing a page reload/remount
            const newUrl = `/${newSession.id}/form-builder`;
            window.history.replaceState(null, '', newUrl);
            console.log("🔄 URL updated to:", newUrl);
            // Only close the modal if session creation was successful
            setShowTemplateModal(false);
        }
        catch (err) {
            console.error("❌ Failed to create session from template:", err);
            setError("Failed to create session from template. Please try again.");
            // Don't close the modal on error so user can try again
        }
    });
    const handleCloseModal = () => {
        setShowTemplateModal(false);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [children, (session === null || session === void 0 ? void 0 : session.docType) === sessionBuilder_1.DOC_TYPE.PPT && !newTemplateGenerate && ((0, jsx_runtime_1.jsx)(TemplateSelectionModal_1.default, { open: showTemplateModal, onClose: handleCloseModal, onSelectTemplate: handleSelectTemplate, docType: sessionBuilder_1.DOC_TYPE.PPT }))] }));
};
exports.default = TemplateSelectionWrapper;
